import React, { Component } from "react";
import { Overlay } from "../Overlay/Overlay";
import { Button, createStandaloneToast } from "@chakra-ui/react";
import APIService from "../Services/APIService";
import { CommonMethodService } from "../Services/CommonMethodService";
import { ForgotPasswordRequest } from "../modals/ForgotPasswordRequest";
import { IBodyshopService } from "../UserService";
require("./forgotPassword.css");

export interface Props {
  closeModal: () => void;
}
export interface State {
  email: string;
  isSent: boolean;
  isLoading: boolean;
}

const toast = createStandaloneToast();
export default class ForgotPassword extends Component<Props, State> {
  private apiService: APIService;
  private ibsService: IBodyshopService;

  constructor(props: any) {
    super(props);
    this.state = {
      email: "",
      isSent: false,
      isLoading: false,
    };
    this.apiService = new APIService();
    this.ibsService = new IBodyshopService();
  }

  isValidEmail(email: string) {
    if (!email) {
      return true;
    }

    return /\S+@\S+\.\S+/.test(email);
  }

  async forgotPassword() {
    this.setState({ isLoading: true });
    const params = CommonMethodService.params();
    const forgotPasswordPayload: ForgotPasswordRequest = {
      email: this.state.email,
      estimateId: params.estimateid,
    };
    const response = await this.apiService.forgotPassword(forgotPasswordPayload);
    if (response.ok) {
      this.setState({ isSent: true });
      toast({
        description: "Email Sent Successfully",
        status: "success",
        duration: 1500,
        isClosable: true,
      });
      this.props.closeModal();
      this.setState({ isLoading: false });
    } else {
      this.setState({ isLoading: false });
      let message = "";
      if (response.status === 404) {
        message = "Please enter a valid email";
      } else {
        message = "Something went wrong.";
      }
      toast({
        description: message,
        status: "error",
        duration: 1500,
        isClosable: true,
      });
    }
  }

  render() {
    return (
      <div className="forgot-password-dialog-container">
        <Overlay isMenuOverlay={true} closeModal={this.props.closeModal}></Overlay>
        <div className={"container-forgot container"}>
          <div className={"title-forgot"}>Forgot Password</div>
          {!this.state.isSent && <div className={"messageTextContainer"}>Enter your email address and we’ll send you a link to reset you password.</div>}
          {!this.state.isSent && (
            <>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.forgotPassword();
                }}
              >
                <div className="input-wrapper">
                  <input
                    className={["input-forgot", this.isValidEmail(this.state.email) ? "" : "invalid-email"].join(" ")}
                    placeholder="Email address"
                    value={this.state.email}
                    onChange={(e) => {
                      this.setState({ email: e.currentTarget.value });
                    }}
                    type="email"
                    required
                  />
                  {this.isValidEmail(this.state.email) ? <></> : <span className="invalid-email">Invalid email</span>}
                </div>
                <div className="button-forgot">
                  {this.state.isLoading ? (
                    <button className="btn btn-forget-loading" type="button" disabled>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                  ) : (
                    <Button
                      style={{ width: "100%" }}
                      colorScheme={"blue"}
                      variant={"solid"}
                      disabled={!this.state.email || !this.isValidEmail(this.state.email)}
                      onClick={() => this.forgotPassword()}
                    >
                      RESET PASSWORD
                    </Button>
                  )}
                </div>
              </form>
              <p className="small-text" onClick={() => this.props.closeModal()}>
                Log in to Customer Portal
              </p>
            </>
          )}
          {this.state.isSent && <div className={"messageTextContainer"}>We’ve sent you an email with a link to reset your password.</div>}
        </div>
      </div>
    );
  }
}
